// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * WL.Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { ActivityResultResponseRepresentationData } from './ActivityResultResponseRepresentationData'
import {
  ActivityResultResponseRepresentationDataFromJSON,
  ActivityResultResponseRepresentationDataFromJSONTyped,
  ActivityResultResponseRepresentationDataToJSON,
} from './ActivityResultResponseRepresentationData'

/**
 *
 * @export
 * @interface ActivityResultResponseRepresentation
 */
export interface ActivityResultResponseRepresentation {
  /**
   *
   * @type {ActivityResultResponseRepresentationData}
   * @memberof ActivityResultResponseRepresentation
   */
  data: ActivityResultResponseRepresentationData
}

/**
 * Check if a given object implements the ActivityResultResponseRepresentation interface.
 */
export function instanceOfActivityResultResponseRepresentation(
  value: object,
): boolean {
  let isInstance = true
  isInstance = isInstance && 'data' in value

  return isInstance
}

export function ActivityResultResponseRepresentationFromJSON(
  json: any,
): ActivityResultResponseRepresentation {
  return ActivityResultResponseRepresentationFromJSONTyped(json, false)
}

export function ActivityResultResponseRepresentationFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ActivityResultResponseRepresentation {
  if (json === undefined || json === null) {
    return json
  }
  return {
    data: ActivityResultResponseRepresentationDataFromJSON(json['data']),
  }
}

export function ActivityResultResponseRepresentationToJSON(
  value?: ActivityResultResponseRepresentation | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    data: ActivityResultResponseRepresentationDataToJSON(value.data),
  }
}
